import type { FC } from "react";
import DMSMediaPlayer from "@/components/DMSMediaPlayer";
import type { Media } from "@/declarations/models/Media";

export interface AudioPreviewProps {
  identifier?: string;
  title?: string;
  media?: Media;
}

export const AudioPreview: FC<AudioPreviewProps> = ({ identifier, title }) => (
  <DMSMediaPlayer identifier={identifier} title={title || "Audio player"} audio />
);

export default AudioPreview;
